<!--
    Styles
-->

<style>


    /* nav */

    #compare nav {
        position: relative;
        height: 60px;
        border-bottom: 1px solid var(--cl-gray);
    }
    #compare nav a {
        height: 100%;
        justify-content: center;
    }
    #compare nav a svg {
        width: 24px;
        height: 24px;
    }
    #compare nav .back {
        width: 50px;
    }
    #compare nav .button {
        width: 165px;
    }
    #compare nav .button.clear {
        border-left: 1px solid var(--cl-gray);
    }
    #compare nav .button.download {
        background: var(--cl-orange);
    }
    #compare nav .button.download svg {
        margin-right: 6px;
    }
    #compare nav .button.download.disabled {
        background: var(--cl-gray);
        pointer-events: none;
    }
    #compare nav .loader {
        top: 100%;
    }


    /* stats */

    #compare .stats {
        justify-content: flex-end;
        height: 412px;
    }
    #compare .stats .map {
        width: 640px;
    }


    /* chart */

    #compare .price {
        justify-content: stretch;
    }
    #compare .price .heading {
        padding: 0 16px;
        line-height: 42px;
        border-bottom: 1px solid var(--cl-gray);
    }
    #compare .price .average {
        padding: 8px 16px;
    }
    #compare .price .average .label {
        margin-left: 16px;
        margin-right: 8px;
    }
    #compare .price .average .label:first-child {
        margin-left: 0;
    }
    #compare .price .chart {
        border: 1px solid var(--cl-gray);
        margin: 0 16px 16px 16px;
        padding: 16px;
    }

    #compare .price .legend {
        width: 70%;
        margin: 0 auto;
        justify-content: center;
        padding: 8px 16px;
        background: var(--cl-white-dark)
    }
    #compare .price .legend i {
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 6px;
        margin-right: 4px;
        margin-left: 24px;
        background: currentColor;
    }
    #compare .price .legend i:first-child {
        margin-left: 0;
    }


    /* table */

    #compare table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed
    }
    #compare table td {
        padding: 4px 6px;
        border: 1px solid var(--cl-gray);
    }
    #compare table td:first-child {
        width: 200px;
        background: var(--cl-gray-light);
        border-left: none;
    }
    #compare table td:last-child {
        border-right: none;
    }
    #compare table td.address {
        white-space: pre-line;
    }
    #compare table td.cover {
        position: relative;
        padding: 0;
        height: 155px;
    }
    #compare table td.cover p {
        position: absolute;
        left: 6px;
        top: 4px;
        text-shadow: 0 0 1px var(--cl-black);
    }


</style>



<!--
    Template
-->

<template>
    <section id="compare">


        <!-- nav -->

        <nav class="u-row">

            <a class="back u-row cl-blue" @click="back">
                <icon-back />
            </a>

            <p class="t20 w7 u-flex">周辺相場レポート</p>

            <a class="button clear u-row t15 w7 cl-blue" @click="clear">
                <span>選択をクリア</span>
            </a>

            <!--
            <a class="button download u-row t15 w7 cl-white" :class="{disabled: !selectedDeals.length}" @click="downloadReport">
                <icon-download />
                <span>ダウンロード</span>
            </a>
            -->

            <ui-loader class="loader" v-show="loading" />

        </nav>


        <!-- stats -->

        <div class="stats u-stretch u-row" v-if="selectedDeals.length">


            <!-- price -->

            <div class="price u-flex u-col" v-if="chart">

                <p class="heading t18 w7">周辺相場トレンド</p>

                <div class="average u-row">
                    <p class="label">平均成約価格：</p>
                    <p class="w7">{{ chart.averageDealPrice | price }}円</p>
                    <p class="label">平均坪単価：</p>
                    <p class="w7">{{ chart.averageDealPriceBySqm * tsubo | price }}円</p>
                </div>

                <div class="chart u-flex u-col">

                    <div class="legend u-row">
                        <i class="cl-blue" />
                        <p>平均成約価格</p>
                        <i class="cl-orange" />
                        <p>平均坪単価</p>
                    </div>

                    <chart-prices class="u-flex" :data="chart" />

                </div>
            </div>


            <!-- map -->

            <ui-map class="map" :bounds="bounds" :options="mapOptions" @idle="setChart">
                <marker-building
                    v-for="(building, index) in selected"
                    v-coords="building"
                    :building="building"
                    :index="index + 1"
                    :key="building.id"
                />
            </ui-map>


        </div>


        <!-- table -->

        <table class="t12" v-if="selectedDeals.length">

            <tr>
                <td />
                <td class="cover" v-for="(deal, index) in selectedDeals" :key="deal.id">
                    <ui-image class="u-cover" :src="images[index]" ref="image" />
                    <p class="t18 cl-white">{{ selected.findIndex(building => building.id === deal.building.id) + 1 }}</p>
                </td>
            </tr>

            <tr>
                <td>物件名</td>
                <td class="w7" v-for="deal in selectedDeals" :key="deal.id">{{ deal.building.name }}</td>
            </tr>

            <tr>
                <td>住所</td>
                <td class="address" v-for="deal in selectedDeals" :key="deal.id">{{ deal.building.address | address }}</td>
            </tr>

            <tr>
                <td>価格</td>
                <td v-for="deal in selectedDeals" :key="deal.id">{{ deal.dealPrice | price }}円</td>
            </tr>

            <tr>
                <td>専有･延床面積（m²）</td>
                <td v-for="deal in selectedDeals" :key="deal.id">{{ deal.sqm || deal.totalFloorSqm }}</td>
            </tr>

            <tr>
                <td>坪単価</td>
                <td v-for="deal in selectedDeals" :key="deal.id">{{ deal.dealPrice / (deal.sqm || deal.totalFloorSqm) * tsubo | price(3) }}円</td>
            </tr>

            <tr>
                <td>取引時期</td>
                <td v-for="deal in selectedDeals" :key="deal.id">{{ deal.dealtAt | date }}</td>
            </tr>

            <tr>
                <td>竣工年月</td>
                <td v-for="deal in selectedDeals" :key="deal.id">{{ deal.building.builtAt | date }}</td>
            </tr>

            <tr>
                <td>間取り</td>
                <td v-for="deal in selectedDeals" :key="deal.id">{{ deal.floorPlan }}</td>
            </tr>

            <tr>
                <td>対象階</td>
                <td v-for="deal in selectedDeals" :key="deal.id">{{ deal.floor }} / {{ deal.building.floorsCount }}F</td>
            </tr>

        </table>


    </section>
</template>



<!--
    Scripts
-->

<script>


    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
    import {price, date, address} from '@/common/helpers/parse'
    import API from '@/common/modules/api'
    import maps from '@/common/modules/maps'
    import coords from '@/common/directives/coords'
    import iconBack from '@/assets/icons/back.svg'
    import uiMap from '@/components/shared/ui/map.vue'
    import uiLoader from '@/components/shared/ui/loader.vue'
    import uiImage from '@/components/shared/ui/image.vue'
    import chartPrices from '@/components/shared/charts/prices.vue'
    import markerBuilding from './marker.vue'


    export default {

        components: {
            iconBack,
            uiMap,
            uiLoader,
            uiImage,
            chartPrices,
            markerBuilding
        },

        directives: {
            coords
        },

        filters: {
            price,
            date,
            address
        },

        beforeRouteEnter (to, from, next) {
            next(vm => vm.hasBack = !!from);
        },

        data () {
            return {
                chart: false,
                bounds: false,
                images: [],
                request: {
                    deals: [],
                    chart: false
                },
                mapOptions: {
                    draggable: false,
                    zoomControl: false,
                    scrollwheel: false,
                    disableDoubleClickZoom: true
                }
            }
        },

        computed: {

            ...mapState('search', [
                'selected',
                'params'
            ]),

            ...mapGetters('search', [
                'selectedDeals'
            ]),

            loading () {
                return this.request.deals.length || this.request.chart;
            },
        },

        methods: {

            ...mapMutations('search', [
                'deselect'
            ]),

            ...mapActions('search', [
                'select'
            ]),

            clear () {
                this.deselect();
                this.back();
            },

            back () {
                if (this.hasBack) this.$router.go(-1);
                else this.$router.push('/');
            },

            load () {
                let keys = Object.keys(this.$route.query);
                if (!keys.length) return this.back();
                if (keys.length > 5) keys = keys.splice(0, 5);
                this.request.deals = keys.map(id => API('buildings', {id}));
                Promise.all(this.request.deals)
                    .then(responses => responses.forEach(this.setDeals))
                    .finally(() => {
                        this.request.deals = [];
                        this.selectedDeals.length ? this.init() : this.back();
                    });
            },

            setDeals (response) {
                const building = response.data.buildings[0];
                building && building.deals.forEach(deal => {
                    if (!this.$route.query[building.id].includes(deal.id)) return;
                    this.select({building, deal});
                });
            },

            init () {
                this.setBounds();
                this.$nextTick(this.setImages);
            },

            setBounds () {
                const [lats, lngs] = this.selected.reduce((result, building) => {
                    result[0].push(building.location.coordinates[1]);
                    result[1].push(building.location.coordinates[0]);
                    return result;
                }, [[], []]);
                this.bounds = {
                    south: Math.min.apply(Math, lats),
                    west: Math.min.apply(Math, lngs),
                    north: Math.max.apply(Math, lats),
                    east: Math.max.apply(Math, lngs),
                };
            },

            setChart ({bounds}) {
                const {south, west, north, east} = bounds;
                const {type} = this.params;
                this.request.chart = API('charts', {
                    type,
                    'location[min]': [west, north],
                    'location[max]': [east, south],
                });
                this.request.chart
                    .then(response => this.chart = response.data.tradesAverage)
                    .finally(() => this.request.chart = null)
            },

            setImages () {
                this.images = this.selectedDeals.map((deal, index) => maps.image(deal.building, this.$refs.image[index].$el));
            },

            downloadReport () {
                const {south, west, north, east} = this.bounds;

                return API('report', {
                    ids: this.selectedDeals.map(d => d.id),
                    'location[min]': [west, north],
                    'location[max]': [east, south],
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', '成約レポート.pdf');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
            },

        },

        mounted () {
            this.selectedDeals.length ? this.init() : this.load();
            window.addEventListener('resize', this.setImages);
        },

        destroyed () {
            this.request.chart && API.abort(this.request.chart);
            this.request.deals.forEach(request => API.abort(request));
            window.removeEventListener('resize', this.resize);
        }

    }

</script>

